import { DeviceType, HinavaEcoThermostatInfo, SednaInfo, SplitInfo } from './Device';
import { BindConditionType, BindActionType } from './Bind';
import { getScenarioIcon } from './Scenario';

import { ReactComponent as IconDoorClosed } from 'images/bind/element/door-closed.svg';
import { ReactComponent as IconDoorOpen } from 'images/bind/element/door-open.svg';
import { ReactComponent as IconDoorToggle } from 'images/bind/element/door-toggle.svg';
import { ReactComponent as IconLampOff } from 'images/bind/element/lamp-off.svg';
import { ReactComponent as IconLampOn } from 'images/bind/element/lamp-on.svg';
import { ReactComponent as IconLampToggle } from 'images/bind/element/lamp-toggle.svg';
import { ReactComponent as IconLamp1Off } from 'images/bind/element/lamp-1-off.svg';
import { ReactComponent as IconLamp1On } from 'images/bind/element/lamp-1-on.svg';
import { ReactComponent as IconLamp1Toggle } from 'images/bind/element/lamp-1-toggle.svg';
import { ReactComponent as IconLamp2Off } from 'images/bind/element/lamp-2-off.svg';
import { ReactComponent as IconLamp2On } from 'images/bind/element/lamp-2-on.svg';
import { ReactComponent as IconLamp2Toggle } from 'images/bind/element/lamp-2-toggle.svg';
import { ReactComponent as IconLamp3Off } from 'images/bind/element/lamp-3-off.svg';
import { ReactComponent as IconLamp3On } from 'images/bind/element/lamp-3-on.svg';
import { ReactComponent as IconLamp3Toggle } from 'images/bind/element/lamp-3-toggle.svg';
import { ReactComponent as IconLamp4Off } from 'images/bind/element/lamp-4-off.svg';
import { ReactComponent as IconLamp4On } from 'images/bind/element/lamp-4-on.svg';
import { ReactComponent as IconLamp4Toggle } from 'images/bind/element/lamp-4-toggle.svg';
import { ReactComponent as IconMotionDetected } from 'images/bind/element/motion-detected.svg';
import { ReactComponent as IconMotionNotDetected } from 'images/bind/element/motion-not-detected.svg';
import { ReactComponent as IconSoundDetected } from 'images/bind/element/sound-detected.svg';
import { ReactComponent as IconSoundMute } from 'images/bind/element/sound-mute.svg';
import { ReactComponent as IconPlugOff } from 'images/bind/element/plug-off.svg';
import { ReactComponent as IconPlugOn } from 'images/bind/element/plug-on.svg';
import { ReactComponent as IconPlugToggle } from 'images/bind/element/plug-toggle.svg';
import { ReactComponent as IconSirenAlarming } from 'images/bind/element/siren-alarming.svg';
// import { ReactComponent as IconSirenPluged } from 'images/bind/element/siren-pluged.svg';
import { ReactComponent as IconSirenStandby } from 'images/bind/element/siren-standby.svg';
// import { ReactComponent as IconSirenUnpluged } from 'images/bind/element/siren-unpluged.svg';
import { ReactComponent as IconThermostat } from 'images/device/symbol/blue/thermostat.svg';
import { ReactComponent as IconSplit } from 'images/device/symbol/blue/remote-ac.svg';
import { ReactComponent as IconCooler } from 'images/device/symbol/blue/cooler.svg';
import { ReactComponent as IconTV } from 'images/device/symbol/blue/remote-tv.svg';
import { ReactComponent as IconCurtainOpen1 } from 'images/bind/element/curtain-open-1.svg';
import { ReactComponent as IconCurtainOpen2 } from 'images/bind/element/curtain-open-2.svg';
import { ReactComponent as IconCurtainClose1 } from 'images/bind/element/curtain-close-1.svg';
import { ReactComponent as IconCurtainClose2 } from 'images/bind/element/curtain-close-2.svg';
import { ReactComponent as IconLowBattery } from 'images/bind/element/low-battery.svg';

import { ReactComponent as IconCoolerFanChange } from 'images/bind/element/cooler-fan-change.svg';
import { ReactComponent as IconCoolerFanFast } from 'images/bind/element/cooler-fan-fast.svg';
import { ReactComponent as IconCoolerFanOff } from 'images/bind/element/cooler-fan-off.svg';
import { ReactComponent as IconCoolerFanSlow } from 'images/bind/element/cooler-fan-slow.svg';
import { ReactComponent as IconCoolerPowerChange } from 'images/bind/element/cooler-power-change.svg';
import { ReactComponent as IconCoolerPowerOff } from 'images/bind/element/cooler-power-off.svg';
import { ReactComponent as IconCoolerPowerOn } from 'images/bind/element/cooler-power-on.svg';
import { ReactComponent as IconCoolerPumpChange } from 'images/bind/element/cooler-pump-change.svg';
import { ReactComponent as IconCoolerPumpOff } from 'images/bind/element/cooler-pump-off.svg';
import { ReactComponent as IconCoolerPumpOn } from 'images/bind/element/cooler-pump-on.svg';
import { ReactComponent as IconCoolerFanChangeDark } from 'images/bind/element/cooler-fan-change-dark.svg';
import { ReactComponent as IconCoolerFanFastDark } from 'images/bind/element/cooler-fan-fast-dark.svg';
import { ReactComponent as IconCoolerFanOffDark } from 'images/bind/element/cooler-fan-off-dark.svg';
import { ReactComponent as IconCoolerFanSlowDark } from 'images/bind/element/cooler-fan-slow-dark.svg';
import { ReactComponent as IconCoolerPowerChangeDark } from 'images/bind/element/cooler-power-change-dark.svg';
import { ReactComponent as IconCoolerPowerOffDark } from 'images/bind/element/cooler-power-off-dark.svg';
import { ReactComponent as IconCoolerPowerOnDark } from 'images/bind/element/cooler-power-on-dark.svg';
import { ReactComponent as IconCoolerPumpChangeDark } from 'images/bind/element/cooler-pump-change-dark.svg';
import { ReactComponent as IconCoolerPumpOffDark } from 'images/bind/element/cooler-pump-off-dark.svg';
import { ReactComponent as IconCoolerPumpOnDark } from 'images/bind/element/cooler-pump-on-dark.svg';

import { ReactComponent as IconRelay1Off } from 'images/bind/element/relay-1-off.svg';
import { ReactComponent as IconRelay1On } from 'images/bind/element/relay-1-on.svg';
import { ReactComponent as IconRelay1Toggle } from 'images/bind/element/relay-1-toggle.svg';
import { ReactComponent as IconRelay2Off } from 'images/bind/element/relay-2-off.svg';
import { ReactComponent as IconRelay2On } from 'images/bind/element/relay-2-on.svg';
import { ReactComponent as IconRelay2Toggle } from 'images/bind/element/relay-2-toggle.svg';
import { ReactComponent as IconRelay3Off } from 'images/bind/element/relay-3-off.svg';
import { ReactComponent as IconRelay3On } from 'images/bind/element/relay-3-on.svg';
import { ReactComponent as IconRelay3Toggle } from 'images/bind/element/relay-3-toggle.svg';
import { ReactComponent as IconRelay4Off } from 'images/bind/element/relay-4-off.svg';
import { ReactComponent as IconRelay4On } from 'images/bind/element/relay-4-on.svg';
import { ReactComponent as IconRelay4Toggle } from 'images/bind/element/relay-4-toggle.svg';

import { ReactComponent as IconMusicOffDark } from 'images/bind/element/music-off-dark.svg';
import { ReactComponent as IconMusicOff } from 'images/bind/element/music-off.svg';
import { ReactComponent as IconMusicOnDark } from 'images/bind/element/music-on-dark.svg';
import { ReactComponent as IconMusicOn } from 'images/bind/element/music-on.svg';
import { ReactComponent as IconMusicToggleDark } from 'images/bind/element/music-toggle-dark.svg';
import { ReactComponent as IconMusicToggle } from 'images/bind/element/music-toggle.svg';
import { ReactComponent as IconSprayDark } from 'images/bind/element/spray-dark.svg';
import { ReactComponent as IconSpray } from 'images/bind/element/spray.svg';
import { ReactComponent as IconWcCancelDark } from 'images/bind/element/wc-cancel-dark.svg';
import { ReactComponent as IconWcCancel } from 'images/bind/element/wc-cancel.svg';
// import { ReactComponent as IconWcInUseDark } from 'images/bind/element/wc-in-use-dark.svg';
// import { ReactComponent as IconWcInUse } from 'images/bind/element/wc-in-use.svg';
import { ReactComponent as IconWcRefreshDark } from 'images/bind/element/wc-refresh-dark.svg';
import { ReactComponent as IconWcRefresh } from 'images/bind/element/wc-refresh.svg';

import { ReactComponent as IconDoorbellOffDark } from 'images/bind/element/doorbell-off-dark.svg';
import { ReactComponent as IconDoorbellOff } from 'images/bind/element/doorbell-off.svg';
import { ReactComponent as IconDoorbellOnDark } from 'images/bind/element/doorbell-on-dark.svg';
import { ReactComponent as IconDoorbellOn } from 'images/bind/element/doorbell-on.svg';
import { ReactComponent as IconDoorbellToggleDark } from 'images/bind/element/doorbell-toggle-dark.svg';
import { ReactComponent as IconDoorbellToggle } from 'images/bind/element/doorbell-toggle.svg';
import { ReactComponent as IconElevatorOffDark } from 'images/bind/element/elevator-off-dark.svg';
import { ReactComponent as IconElevatorOff } from 'images/bind/element/elevator-off.svg';
import { ReactComponent as IconElevatorOnDark } from 'images/bind/element/elevator-on-dark.svg';
import { ReactComponent as IconElevatorOn } from 'images/bind/element/elevator-on.svg';
import { ReactComponent as IconElevatorToggleDark } from 'images/bind/element/elevator-toggle-dark.svg';
import { ReactComponent as IconElevatorToggle } from 'images/bind/element/elevator-toggle.svg';

import { ReactComponent as IconCurtainClose1Dark } from 'images/bind/element/curtain-close-1-dark.svg';
import { ReactComponent as IconCurtainClose2Dark } from 'images/bind/element/curtain-close-2-dark.svg';
import { ReactComponent as IconCurtainOpen1Dark } from 'images/bind/element/curtain-open-1-dark.svg';
import { ReactComponent as IconCurtainOpen2Dark } from 'images/bind/element/curtain-open-2-dark.svg';
import { ReactComponent as IconDoorClosedDark } from 'images/bind/element/door-closed-dark.svg';
import { ReactComponent as IconDoorOpenDark } from 'images/bind/element/door-open-dark.svg';
import { ReactComponent as IconDoorToggleDark } from 'images/bind/element/door-toggle-dark.svg';
import { ReactComponent as IconLampOffDark } from 'images/bind/element/lamp-off-dark.svg';
import { ReactComponent as IconLampOnDark } from 'images/bind/element/lamp-on-dark.svg';
import { ReactComponent as IconLampToggleDark } from 'images/bind/element/lamp-toggle-dark.svg';
import { ReactComponent as IconLamp1OffDark } from 'images/bind/element/lamp-1-off-dark.svg';
import { ReactComponent as IconLamp1OnDark } from 'images/bind/element/lamp-1-on-dark.svg';
import { ReactComponent as IconLamp1ToggleDark } from 'images/bind/element/lamp-1-toggle-dark.svg';
import { ReactComponent as IconLamp2OffDark } from 'images/bind/element/lamp-2-off-dark.svg';
import { ReactComponent as IconLamp2OnDark } from 'images/bind/element/lamp-2-on-dark.svg';
import { ReactComponent as IconLamp2ToggleDark } from 'images/bind/element/lamp-2-toggle-dark.svg';
import { ReactComponent as IconLamp3OffDark } from 'images/bind/element/lamp-3-off-dark.svg';
import { ReactComponent as IconLamp3OnDark } from 'images/bind/element/lamp-3-on-dark.svg';
import { ReactComponent as IconLamp3ToggleDark } from 'images/bind/element/lamp-3-toggle-dark.svg';
import { ReactComponent as IconLamp4OffDark } from 'images/bind/element/lamp-4-off-dark.svg';
import { ReactComponent as IconLamp4OnDark } from 'images/bind/element/lamp-4-on-dark.svg';
import { ReactComponent as IconLamp4ToggleDark } from 'images/bind/element/lamp-4-toggle-dark.svg';
import { ReactComponent as IconMotionDetectedDark } from 'images/bind/element/motion-detected-dark.svg';
import { ReactComponent as IconMotionNotDetectedDark } from 'images/bind/element/motion-not-detected-dark.svg';
import { ReactComponent as IconSoundDetectedDark } from 'images/bind/element/sound-detected-dark.svg';
import { ReactComponent as IconSoundMuteDark } from 'images/bind/element/sound-mute-dark.svg';
import { ReactComponent as IconPlugOffDark } from 'images/bind/element/plug-off-dark.svg';
import { ReactComponent as IconPlugOnDark } from 'images/bind/element/plug-on-dark.svg';
import { ReactComponent as IconPlugToggleDark } from 'images/bind/element/plug-toggle-dark.svg';
import { ReactComponent as IconRelay1OffDark } from 'images/bind/element/relay-1-off-dark.svg';
import { ReactComponent as IconRelay1OnDark } from 'images/bind/element/relay-1-on-dark.svg';
import { ReactComponent as IconRelay1ToggleDark } from 'images/bind/element/relay-1-toggle-dark.svg';
import { ReactComponent as IconRelay2OffDark } from 'images/bind/element/relay-2-off-dark.svg';
import { ReactComponent as IconRelay2OnDark } from 'images/bind/element/relay-2-on-dark.svg';
import { ReactComponent as IconRelay2ToggleDark } from 'images/bind/element/relay-2-toggle-dark.svg';
import { ReactComponent as IconRelay3OffDark } from 'images/bind/element/relay-3-off-dark.svg';
import { ReactComponent as IconRelay3OnDark } from 'images/bind/element/relay-3-on-dark.svg';
import { ReactComponent as IconRelay3ToggleDark } from 'images/bind/element/relay-3-toggle-dark.svg';
import { ReactComponent as IconRelay4OffDark } from 'images/bind/element/relay-4-off-dark.svg';
import { ReactComponent as IconRelay4OnDark } from 'images/bind/element/relay-4-on-dark.svg';
import { ReactComponent as IconRelay4ToggleDark } from 'images/bind/element/relay-4-toggle-dark.svg';
import { ReactComponent as IconSirenAlarmingDark } from 'images/bind/element/siren-alarming-dark.svg';
// import { ReactComponent as IconSirenPlugedDark } from 'images/bind/element/siren-pluged-dark.svg';
import { ReactComponent as IconSirenStandbyDark } from 'images/bind/element/siren-standby-dark.svg';
// import { ReactComponent as IconSirenUnplugedDark } from 'images/bind/element/siren-unpluged-dark.svg';
import { ReactComponent as IconLowBatteryDark } from 'images/bind/element/low-battery-dark.svg';

import { ReactComponent as IconLightOff } from 'images/bind/element/light-off.svg';
import { ReactComponent as IconLightNormal } from 'images/bind/element/light-normal.svg';
import { ReactComponent as IconLightBright } from 'images/bind/element/light-bright.svg';
import { ReactComponent as IconHumidity } from 'images/bind/element/humidity.svg';
import { ReactComponent as IconTemp } from 'images/bind/element/temp.svg';
import { ReactComponent as IconAlarm } from 'images/bind/element/alarm.svg';
import { ReactComponent as IconCall } from 'images/bind/element/call.svg';
import { ReactComponent as IconEmail } from 'images/bind/element/email.svg';
import { ReactComponent as IconNotif } from 'images/bind/element/notif.svg';
import { ReactComponent as IconSms } from 'images/bind/element/sms.svg';

export const BindTemplateType = {
    optionList: 0, // have sections
    special: 1, // the tamplate have an icon
}

export const BindSectionType = {
    oneOf: 0,
    comparisonWithSlider: 1,
}

export const BindSliderType = {
    temperature: 0,
    humidity: 1,
    brightness: 2,
}

const actuatorColor = "#23D4FF"; // blue
const sensorColor = "#FFC900"; // yellow

export function getBindTemplate(forCondition, device, localization) {
    const deviceType = device.type;

    const b = localization.strings.bindText;

    const forAction = !forCondition;

    let tempReturnValue = {
        type: BindTemplateType.optionList,
        sections: []
    }; // used for (lamp2-3-4) & (curtain) & (unknown types).

    switch (deviceType) {
        case DeviceType.doorSensor:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.door,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconDoorOpen,
                            iconDark: IconDoorOpenDark,
                            title: b.opened,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconDoorClosed,
                            iconDark: IconDoorClosedDark,
                            title: b.closed,
                            key: "state",
                            value: 0,
                        }, {
                            icon: IconDoorToggle,
                            iconDark: IconDoorToggleDark,
                            title: b.changed,
                            key: "state",
                            value: 2,
                        },
                    ]
                }];
            }
            return tempReturnValue;
        case DeviceType.wifiDoorSensor:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.door,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconDoorOpen,
                            iconDark: IconDoorOpenDark,
                            title: b.opened,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconDoorClosed,
                            iconDark: IconDoorClosedDark,
                            title: b.closed,
                            key: "state",
                            value: 0,
                        }, {
                            icon: IconDoorToggle,
                            iconDark: IconDoorToggleDark,
                            title: b.changed,
                            key: "state",
                            value: 2,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.power,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconPlugOn,
                            iconDark: IconPlugOnDark,
                            title: b.powerPluged,
                            key: "power_enable",
                            value: 1,
                        }, {
                            icon: IconPlugOff,
                            iconDark: IconPlugOffDark,
                            title: b.powerUnpluged,
                            key: "power_enable",
                            value: 0,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.batteryLevel,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconLowBattery,
                            iconDark: IconLowBatteryDark,
                            title: b.batteryLevelBecameCritical,
                            key: "critical_battery",
                            value: 1,
                        },
                    ]
                }];
            }
            return tempReturnValue;
        case DeviceType.motion:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.motion,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconMotionDetected,
                            iconDark: IconMotionDetectedDark,
                            title: b.motionDetected,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconMotionNotDetected,
                            iconDark: IconMotionNotDetectedDark,
                            title: b.motionStopped,
                            key: "state",
                            value: 0,
                        },
                    ]
                }]
            }
            return tempReturnValue;
        case DeviceType.wifiMotionSensor:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.motion,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconMotionDetected,
                            iconDark: IconMotionDetectedDark,
                            title: b.motionDetected,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconMotionNotDetected,
                            iconDark: IconMotionNotDetectedDark,
                            title: b.motionStopped,
                            key: "state",
                            value: 0,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.power,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconPlugOn,
                            iconDark: IconPlugOnDark,
                            title: b.powerPluged,
                            key: "power_enable",
                            value: 1,
                        }, {
                            icon: IconPlugOff,
                            iconDark: IconPlugOffDark,
                            title: b.powerUnpluged,
                            key: "power_enable",
                            value: 0,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.batteryLevel,
                    itemsHaveIndependentName: false,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconLowBattery,
                            iconDark: IconLowBatteryDark,
                            title: b.batteryLevelBecameCritical,
                            key: "critical_battery",
                            value: 1,
                        },
                    ]
                }]
            }
            return tempReturnValue;
        case DeviceType.multipurposeSensor:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.motion,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconMotionDetected,
                            iconDark: IconMotionDetectedDark,
                            title: b.motionDetected,
                            key: "motion",
                            value: 1,
                        }, {
                            icon: IconMotionNotDetected,
                            iconDark: IconMotionNotDetectedDark,
                            title: b.motionStopped,
                            key: "motion",
                            value: 0,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.sound,
                    itemsHaveIndependentName: true,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconSoundDetected,
                            iconDark: IconSoundDetectedDark,
                            title: b.soundDetected,
                            key: "sound",
                            value: 1,
                        }, {
                            icon: IconSoundMute,
                            iconDark: IconSoundMuteDark,
                            title: b.soundSilenced,
                            key: "sound",
                            value: 0,
                        },
                    ]
                },
                {
                    type: BindSectionType.comparisonWithSlider,
                    name: b.temperature,
                    itemsHaveIndependentName: false,
                    color: sensorColor,
                    sliderType: BindSliderType.temperature,
                    defaulSliderValue: 25,
                    key: "temperature",
                },
                {
                    type: BindSectionType.comparisonWithSlider,
                    name: b.humidity,
                    itemsHaveIndependentName: false,
                    color: sensorColor,
                    sliderType: BindSliderType.humidity,
                    defaulSliderValue: 40,
                    key: "humidity",
                },
                {
                    type: BindSectionType.comparisonWithSlider,
                    name: b.lightLevel,
                    itemsHaveIndependentName: false,
                    color: sensorColor,
                    sliderType: BindSliderType.brightness,
                    defaulSliderValue: 3,
                    key: "light_level",
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.batteryLevel,
                    itemsHaveIndependentName: false,
                    color: sensorColor,
                    items: [
                        {
                            icon: IconLowBattery,
                            iconDark: IconLowBatteryDark,
                            title: b.batteryLevelBecameCritical,
                            key: "critical_battery",
                            value: 1,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.power,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconPlugOn,
                            iconDark: IconPlugOnDark,
                            title: b.powerPluged,
                            key: "power_enable",
                            value: 1,
                        }, {
                            icon: IconPlugOff,
                            iconDark: IconPlugOffDark,
                            title: b.powerUnpluged,
                            key: "power_enable",
                            value: 0,
                        },
                    ]
                }]
            }
            return tempReturnValue;
        case DeviceType.siren:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.alarmSection,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconSirenAlarming,
                            iconDark: IconSirenAlarmingDark,
                            title: b.alarming,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconSirenStandby,
                            iconDark: IconSirenStandbyDark,
                            title: b.silenced,
                            key: "state",
                            value: 0,
                        },
                    ]
                },
                {
                    type: BindSectionType.oneOf,
                    name: b.power,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconPlugOn,
                            iconDark: IconPlugOnDark,
                            title: b.powerPluged,
                            key: "power_enable",
                            value: 1,
                        }, {
                            icon: IconPlugOff,
                            iconDark: IconPlugOffDark,
                            title: b.powerUnpluged,
                            key: "power_enable",
                            value: 0,
                        },
                    ]
                }];
            } else if (forAction) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.alarm,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconSirenAlarming,
                            iconDark: IconSirenAlarmingDark,
                            title: b.alarm,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconSirenStandby,
                            iconDark: IconSirenStandbyDark,
                            title: b.silence,
                            key: "state",
                            value: 0,
                        },
                    ]
                }];
            }
            return tempReturnValue;
        case DeviceType.evaporativeCooler:
            if (forCondition) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.coolerPowerSection,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCoolerPowerOn,
                            iconDark: IconCoolerPowerOnDark,
                            title: b.turnedOn,
                            key: "power",
                            value: 1,
                        }, {
                            icon: IconCoolerPowerOff,
                            iconDark: IconCoolerPowerOffDark,
                            title: b.turnedOff,
                            key: "power",
                            value: 0,
                        }, {
                            icon: IconCoolerPowerChange,
                            iconDark: IconCoolerPowerChangeDark,
                            title: b.changed,
                            key: "power",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.coolerPumpSection,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCoolerPumpOn,
                            iconDark: IconCoolerPumpOnDark,
                            title: b.turnedOn,
                            key: "pump",
                            value: 1,
                        }, {
                            icon: IconCoolerPumpOff,
                            iconDark: IconCoolerPumpOffDark,
                            title: b.turnedOff,
                            key: "pump",
                            value: 0,
                        }, {
                            icon: IconCoolerPumpChange,
                            iconDark: IconCoolerPumpChangeDark,
                            title: b.changed,
                            key: "pump",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.coolerFanSection,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCoolerFanOff,
                            iconDark: IconCoolerFanOffDark,
                            title: b.turnedOff,
                            key: "fan",
                            value: 0,
                        }, {
                            icon: IconCoolerFanSlow,
                            iconDark: IconCoolerFanSlowDark,
                            title: b.didSetToSlow,
                            key: "fan",
                            value: 1,
                        }, {
                            icon: IconCoolerFanFast,
                            iconDark: IconCoolerFanFastDark,
                            title: b.didSetToFast,
                            key: "fan",
                            value: 2,
                        }, {
                            icon: IconCoolerFanChange,
                            iconDark: IconCoolerFanChangeDark,
                            title: b.changed,
                            key: "fan",
                            value: 3,
                        },
                    ]
                },];
            } else if (forAction) {
                return {
                    type: BindTemplateType.special,
                    icon: IconCooler,
                }
            }
            return tempReturnValue;
        case DeviceType.sedna:
        case DeviceType.hinavaEcoThermostat:
            // if: temp
            // then: set state
            return {
                type: BindTemplateType.special,
                icon: forCondition ? IconTemp : IconThermostat,
            }
        case DeviceType.splitRemote:
            // if: -
            // then: set state
            return {
                type: BindTemplateType.special,
                icon: IconSplit,
            }
        case DeviceType.tvRemote:
            // if: -
            // then: power / mute / channel num pad
            return {
                type: BindTemplateType.special,
                icon: IconTV,
            }
        case DeviceType.plug:
            return {
                type: BindTemplateType.optionList,
                sections: [{
                    type: BindSectionType.oneOf,
                    name: b.power,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconPlugOn,
                            iconDark: IconPlugOnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconPlugOff,
                            iconDark: IconPlugOffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "state",
                            value: 0,
                        }, {
                            icon: IconPlugToggle,
                            iconDark: IconPlugToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "state",
                            value: 2,
                        },
                    ]
                }]
            }
        case DeviceType.wc:
            return {
                type: BindTemplateType.optionList,
                sections: [
                    {
                        type: BindSectionType.oneOf,
                        name: b.wcScenario,
                        itemsHaveIndependentName: true,
                        color: actuatorColor,
                        items: [
                            // {
                            //     icon: IconWcInUse,
                            //     iconDark: IconWcInUseDark,
                            //     title: b.inUse,
                            //     key: "scenario",
                            //     value: 1,
                            // }, 
                            {
                                icon: IconWcRefresh,
                                iconDark: IconWcRefreshDark,
                                title: forCondition ? b.refreshed : b.refresh,
                                key: "scenario",
                                value: 2,
                            }, {
                                icon: IconWcCancel,
                                iconDark: IconWcCancelDark,
                                title: forCondition ? b.canceledRefresh : b.cancelRefresh,
                                key: "scenario",
                                value: 0,
                            }
                        ]
                    }, {
                        type: BindSectionType.oneOf,
                        name: b.lamp,
                        itemsHaveIndependentName: false,
                        color: actuatorColor,
                        items: [
                            {
                                icon: IconLampOn,
                                iconDark: IconLampOnDark,
                                title: forCondition ? b.turnedOn : b.turnOn,
                                key: "lamp",
                                value: 1,
                            }, {
                                icon: IconLampOff,
                                iconDark: IconLampOffDark,
                                title: forCondition ? b.turnedOff : b.turnOff,
                                key: "lamp",
                                value: 0,
                            }, {
                                icon: IconLampToggle,
                                iconDark: IconLampToggleDark,
                                title: forCondition ? b.changed : b.change,
                                key: "lamp",
                                value: 2,
                            },
                        ]
                    }, {
                        type: BindSectionType.oneOf,
                        name: b.fan,
                        itemsHaveIndependentName: false,
                        color: actuatorColor,
                        items: [
                            {
                                icon: IconCoolerFanFast,
                                iconDark: IconCoolerFanFastDark,
                                title: forCondition ? b.turnedOn : b.turnOn,
                                key: "fan",
                                value: 1,
                            }, {
                                icon: IconCoolerFanOff,
                                iconDark: IconCoolerFanOffDark,
                                title: forCondition ? b.turnedOff : b.turnOff,
                                key: "fan",
                                value: 0,
                            }, {
                                icon: IconCoolerFanChange,
                                iconDark: IconCoolerFanChangeDark,
                                title: forCondition ? b.changed : b.change,
                                key: "fan",
                                value: 2,
                            },
                        ]
                    }, {
                        type: BindSectionType.oneOf,
                        name: b.spray,
                        itemsHaveIndependentName: false,
                        color: actuatorColor,
                        items: [
                            {
                                icon: IconSpray,
                                iconDark: IconSprayDark,
                                title: forCondition ? b.didSpray : b.doSpray,
                                key: "spray",
                                value: 1,
                            }
                        ]
                    }, {
                        type: BindSectionType.oneOf,
                        name: b.music,
                        itemsHaveIndependentName: false,
                        color: actuatorColor,
                        items: [
                            {
                                icon: IconMusicOn,
                                iconDark: IconMusicOnDark,
                                title: forCondition ? b.turnedOn : b.turnOn,
                                key: "music",
                                value: 1,
                            }, {
                                icon: IconMusicOff,
                                iconDark: IconMusicOffDark,
                                title: forCondition ? b.turnedOff : b.turnOff,
                                key: "music",
                                value: 0,
                            }, {
                                icon: IconMusicToggle,
                                iconDark: IconMusicToggleDark,
                                title: forCondition ? b.changed : b.change,
                                key: "music",
                                value: 2,
                            },
                        ]
                    }
                ]
            }
        case DeviceType.elevator1:
            return {
                type: BindTemplateType.optionList,
                sections: [{
                    type: BindSectionType.oneOf,
                    name: b.elevator,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconElevatorOn,
                            iconDark: IconElevatorOnDark,
                            title: forCondition ? b.calledElevator : b.callElevator,
                            key: "state1",
                            value: 1,
                        }, {
                            icon: IconElevatorOff,
                            iconDark: IconElevatorOffDark,
                            title: forCondition ? b.canceled : b.cancel,
                            key: "state1",
                            value: 0,
                        }, {
                            icon: IconElevatorToggle,
                            iconDark: IconElevatorToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "state1",
                            value: 2,
                        },
                    ]
                }]
            }
        case DeviceType.doorbell:
            return {
                type: BindTemplateType.optionList,
                sections: [{
                    type: BindSectionType.oneOf,
                    name: b.doorbell,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconDoorbellOn,
                            iconDark: IconDoorbellOnDark,
                            title: forCondition ? b.rang : b.ring,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconDoorbellOff,
                            iconDark: IconDoorbellOffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "state",
                            value: 0,
                        }, {
                            icon: IconDoorbellToggle,
                            iconDark: IconDoorbellToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "state",
                            value: 2,
                        },
                    ]
                }]
            }
        case DeviceType.lamp:
        case DeviceType.lampX1TwoWay:
            return {
                type: BindTemplateType.optionList,
                sections: [{
                    type: BindSectionType.oneOf,
                    name: b.switch,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconLamp1On,
                            iconDark: IconLamp1OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "state",
                            value: 1,
                        }, {
                            icon: IconLamp1Off,
                            iconDark: IconLamp1OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "state",
                            value: 0,
                        }, {
                            icon: IconLamp1Toggle,
                            iconDark: IconLamp1ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "state",
                            value: 2,
                        },
                    ]
                }]
            }
        case DeviceType.lampX4:
            tempReturnValue.sections.unshift({
                type: BindSectionType.oneOf,
                name: b.switch4,
                itemsHaveIndependentName: false,
                color: actuatorColor,
                items: [
                    {
                        icon: IconLamp4On,
                        iconDark: IconLamp4OnDark,
                        title: forCondition ? b.turnedOn : b.turnOn,
                        key: "state4",
                        value: 1,
                    }, {
                        icon: IconLamp4Off,
                        iconDark: IconLamp4OffDark,
                        title: forCondition ? b.turnedOff : b.turnOff,
                        key: "state4",
                        value: 0,
                    }, {
                        icon: IconLamp4Toggle,
                        iconDark: IconLamp4ToggleDark,
                        title: forCondition ? b.changed : b.change,
                        key: "state4",
                        value: 2,
                    },
                ]
            });
        // eslint-disable-next-line no-fallthrough
        case DeviceType.lampX3:
            tempReturnValue.sections.unshift({
                type: BindSectionType.oneOf,
                name: b.switch3,
                itemsHaveIndependentName: false,
                color: actuatorColor,
                items: [
                    {
                        icon: IconLamp3On,
                        iconDark: IconLamp3OnDark,
                        title: forCondition ? b.turnedOn : b.turnOn,
                        key: "state3",
                        value: 1,
                    }, {
                        icon: IconLamp3Off,
                        iconDark: IconLamp3OffDark,
                        title: forCondition ? b.turnedOff : b.turnOff,
                        key: "state3",
                        value: 0,
                    }, {
                        icon: IconLamp3Toggle,
                        iconDark: IconLamp3ToggleDark,
                        title: forCondition ? b.changed : b.change,
                        key: "state3",
                        value: 2,
                    },
                ]
            });
        // eslint-disable-next-line no-fallthrough
        case DeviceType.dpst:
            tempReturnValue.sections.unshift({
                type: BindSectionType.oneOf,
                name: b.switch2,
                itemsHaveIndependentName: false,
                color: actuatorColor,
                items: [
                    {
                        icon: IconLamp2On,
                        iconDark: IconLamp2OnDark,
                        title: forCondition ? b.turnedOn : b.turnOn,
                        key: "state2",
                        value: 1,
                    }, {
                        icon: IconLamp2Off,
                        iconDark: IconLamp2OffDark,
                        title: forCondition ? b.turnedOff : b.turnOff,
                        key: "state2",
                        value: 0,
                    }, {
                        icon: IconLamp2Toggle,
                        iconDark: IconLamp2ToggleDark,
                        title: forCondition ? b.changed : b.change,
                        key: "state2",
                        value: 2,
                    },
                ]
            });
            tempReturnValue.sections.unshift({
                type: BindSectionType.oneOf,
                name: b.switch1,
                itemsHaveIndependentName: false,
                color: actuatorColor,
                items: [
                    {
                        icon: IconLamp1On,
                        iconDark: IconLamp1OnDark,
                        title: forCondition ? b.turnedOn : b.turnOn,
                        key: "state1",
                        value: 1,
                    }, {
                        icon: IconLamp1Off,
                        iconDark: IconLamp1OffDark,
                        title: forCondition ? b.turnedOff : b.turnOff,
                        key: "state1",
                        value: 0,
                    }, {
                        icon: IconLamp1Toggle,
                        iconDark: IconLamp1ToggleDark,
                        title: forCondition ? b.changed : b.change,
                        key: "state1",
                        value: 2,
                    },
                ]
            });
            return tempReturnValue;
        case DeviceType.relay4:
            return {
                type: BindTemplateType.optionList,
                sections: [{
                    type: BindSectionType.oneOf,
                    name: b.channel1,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconRelay1On,
                            iconDark: IconRelay1OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "channel1",
                            value: 1,
                        }, {
                            icon: IconRelay1Off,
                            iconDark: IconRelay1OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "channel1",
                            value: 0,
                        }, {
                            icon: IconRelay1Toggle,
                            iconDark: IconRelay1ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "channel1",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.channel2,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconRelay2On,
                            iconDark: IconRelay2OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "channel2",
                            value: 1,
                        }, {
                            icon: IconRelay2Off,
                            iconDark: IconRelay2OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "channel2",
                            value: 0,
                        }, {
                            icon: IconRelay2Toggle,
                            iconDark: IconRelay2ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "channel2",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.channel3,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconRelay3On,
                            iconDark: IconRelay3OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "channel3",
                            value: 1,
                        }, {
                            icon: IconRelay3Off,
                            iconDark: IconRelay3OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "channel3",
                            value: 0,
                        }, {
                            icon: IconRelay3Toggle,
                            iconDark: IconRelay3ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "channel3",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.channel4,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconRelay4On,
                            iconDark: IconRelay4OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "channel4",
                            value: 1,
                        }, {
                            icon: IconRelay4Off,
                            iconDark: IconRelay4OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "channel4",
                            value: 0,
                        }, {
                            icon: IconRelay4Toggle,
                            iconDark: IconRelay4ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "channel4",
                            value: 2,
                        },
                    ]
                }]
            }
        case DeviceType.curtain1Lamp2:
            return {
                type: BindTemplateType.optionList,
                sections: [{
                    type: BindSectionType.oneOf,
                    name: b.switch1,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconLamp1On,
                            iconDark: IconLamp1OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "lamp1",
                            value: 1,
                        }, {
                            icon: IconLamp1Off,
                            iconDark: IconLamp1OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "lamp1",
                            value: 0,
                        }, {
                            icon: IconLamp1Toggle,
                            iconDark: IconLamp1ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "lamp1",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.switch2,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconLamp2On,
                            iconDark: IconLamp2OnDark,
                            title: forCondition ? b.turnedOn : b.turnOn,
                            key: "lamp2",
                            value: 1,
                        }, {
                            icon: IconLamp2Off,
                            iconDark: IconLamp2OffDark,
                            title: forCondition ? b.turnedOff : b.turnOff,
                            key: "lamp2",
                            value: 0,
                        }, {
                            icon: IconLamp2Toggle,
                            iconDark: IconLamp2ToggleDark,
                            title: forCondition ? b.changed : b.change,
                            key: "lamp2",
                            value: 2,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.curtain,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCurtainOpen1,
                            iconDark: IconCurtainOpen1Dark,
                            title: forCondition ? b.opened : b.open,
                            key: "curtain",
                            value: 1,
                        }, {
                            icon: IconCurtainClose1,
                            iconDark: IconCurtainClose1Dark,
                            title: forCondition ? b.closed : b.close,
                            key: "curtain",
                            value: 0,
                        },
                    ]
                }]
            };
        case DeviceType.curtain:
            if (device.num_channels === 1) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.curtain,
                    itemsHaveIndependentName: true,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCurtainOpen1,
                            iconDark: IconCurtainOpen1Dark,
                            title: forCondition ? b.opened : b.open,
                            key: "channel1",
                            value: 1,
                        }, {
                            icon: IconCurtainClose1,
                            iconDark: IconCurtainClose1Dark,
                            title: forCondition ? b.closed : b.close,
                            key: "channel1",
                            value: 0,
                        },
                    ]
                }];
            } else if (device.num_channels === 2) {
                tempReturnValue.sections = [{
                    type: BindSectionType.oneOf,
                    name: b.curtain1,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCurtainOpen1,
                            iconDark: IconCurtainOpen1Dark,
                            title: forCondition ? b.opened : b.open,
                            key: "channel1",
                            value: 1,
                        }, {
                            icon: IconCurtainClose1,
                            iconDark: IconCurtainClose1Dark,
                            title: forCondition ? b.closed : b.close,
                            key: "channel1",
                            value: 0,
                        },
                    ]
                }, {
                    type: BindSectionType.oneOf,
                    name: b.curtain2,
                    itemsHaveIndependentName: false,
                    color: actuatorColor,
                    items: [
                        {
                            icon: IconCurtainOpen2,
                            iconDark: IconCurtainOpen2Dark,
                            title: forCondition ? b.opened : b.open,
                            key: "channel2",
                            value: 1,
                        }, {
                            icon: IconCurtainClose2,
                            iconDark: IconCurtainClose2Dark,
                            title: forCondition ? b.closed : b.close,
                            key: "channel2",
                            value: 0,
                        },
                    ]
                }];
            }
            return tempReturnValue;
        default:
            return tempReturnValue;
    }
}

export function BindInfoObject(repr, data) { return { repr, data } } // data is like cond or act but with only a single item
export function BindReprObject(icon, upperTitle, lowerTitle) { return { icon, upperTitle, lowerTitle } }

const infoToIcon = (info) => { return info.repr.icon };
export function getBindIcons(bind, devices, scenarios, localization) {
    const [conditionInfos, actionInfos] = getBindInfo(bind, devices, scenarios, localization);

    return [
        conditionInfos.map(infoToIcon),
        actionInfos.map(infoToIcon)];
}

export function doesAnyBindHaveError(binds) {
    for (let i = 0; i < binds.length; i++) {
        const bind = binds[i];

        let _noDay = false;
        if (bind.day_of_week !== undefined) {
            _noDay = bind.day_of_week.filter(v => v).length === 0;
        }

        if ((bind.conditions.length === 0) ||
            (bind.actions.length === 0) ||
            (bind.participates_in_cycle === true) ||
            _noDay) {
            return true;
        }
    }
    return false;
}

export function createBindComparisonConditionInfoObject(section, comparisonObject, deviceName, deviceMac, deviceType, localization) {
    const s = localization.strings;
    const b = s.bindText;

    let __infoDataObject = {
        condition_type: BindConditionType.device,
        device_type: deviceType,
        device_mac: deviceMac
    };
    __infoDataObject[section.key] = comparisonObject;

    let text, icon;
    if (section.sliderType === BindSliderType.temperature) {
        icon = IconTemp;
        text = stringFormat(
            b.temperatureConditionF[comparisonObject.comparison],
            localization.localizeNumber(comparisonObject.value.toFixed(1))
        );
    } else if (section.sliderType === BindSliderType.humidity) {
        icon = IconHumidity;
        text = stringFormat(
            b.humidityConditionF[comparisonObject.comparison],
            localization.localizeNumber(comparisonObject.value.toFixed(0))
        );
    } else if (section.sliderType === BindSliderType.brightness) {
        icon = comparisonObject.value <= 1 ? IconLightOff : (comparisonObject.value <= 4 ? IconLightNormal : IconLightBright);
        text = stringFormat(
            b.brighnessConditionF[comparisonObject.comparison],
            s.lightLevels[comparisonObject.value]
        );
    }

    return BindInfoObject(BindReprObject(
        icon,
        deviceName,
        text
    ), __infoDataObject);
}

export function createBindAlarmInfoObject(time, localization) {
    const b = localization.strings.bindText;

    return BindInfoObject(BindReprObject(
        IconAlarm,
        stringFormat(b.alarmF, localization.localizeNumber(time)),
        undefined
    ), {
        condition_type: BindConditionType.alarm,
        time: time
    });
}

export function createBindEmailInfoObject(email, localization) {
    const b = localization.strings.bindText;

    return BindInfoObject(BindReprObject(
        IconEmail,
        stringFormat(b.emailF, email),
        undefined
    ), {
        action_type: BindActionType.email,
        email: email
    });
}

export function createBindSMSInfoObject(pn, localization) {
    const b = localization.strings.bindText;

    return BindInfoObject(BindReprObject(
        IconSms,
        stringFormat(b.smsF, localization.localizeNumber(pn)), 
        // TODO: use markupMobilePhoneNumberWithCountryCode and fix ui rtl issue
        undefined
    ), {
        action_type: BindActionType.sms,
        phone_number: pn
    });
}

export function createBindCallInfoObject(pn, localization) {
    const b = localization.strings.bindText;

    return BindInfoObject(BindReprObject(
        IconCall,
        stringFormat(b.callF, localization.localizeNumber(pn)),
        undefined
    ), {
        action_type: BindActionType.call,
        phone_number: pn
    });
}

export function createBindNotifInfoObject(localization) {
    const b = localization.strings.bindText;

    return BindInfoObject(BindReprObject(
        IconNotif,
        b.notif,
        undefined
    ), {
        action_type: BindActionType.notiftcation,
    });
}

export function createBindScenarioInfoObject(localization, scenario_id, scenarioPicId, scenarioName) {
    const b = localization.strings.bindText;

    return BindInfoObject(BindReprObject(
        getScenarioIcon(scenarioPicId),
        stringFormat(b.scenarioNameF, scenarioName),
        b.run,
    ), {
        action_type: BindActionType.scenario,
        scenario_id: scenario_id
    });
}

export function createBindDeviceSpecialInfoObject(forCondition, icon, deviceName, data, localization) {
    const s = localization.strings;
    const b = s.bindText;
    const se = s.sedna;

    let text = "...";
    if (forCondition) {
        if ((data.device_type === DeviceType.sedna) || (data.device_type === DeviceType.hinavaEcoThermostat)) {
            // console.log("createBindDeviceSpecialInfoObject: data:", data, b.temperatureConditionF[data.temperature.comparison], localization.localizeNumber(data.temperature.value.toFixed(1)));
            text = stringFormat(
                b.temperatureConditionF[data.temperature.comparison],
                localization.localizeNumber(data.temperature.value.toFixed(1))
            );
        }
    } else {
        if (data.device_type === DeviceType.splitRemote) {
            if (data["is_on"]) {
                const modeDict = {};
                modeDict[SplitInfo.mode.heat] = b.splitState.mode.heat;
                modeDict[SplitInfo.mode.cool] = b.splitState.mode.cool;
                modeDict[SplitInfo.mode.dry] = b.splitState.mode.dry;
                modeDict[SplitInfo.mode.auto] = b.splitState.mode.auto;
                modeDict[SplitInfo.mode.fanOnly] = b.splitState.mode.fanOnly;
                const speedDict = {};
                speedDict[SplitInfo.fan.auto] = b.splitState.fan.auto;
                speedDict[SplitInfo.fan.x1] = b.splitState.fan.x1;
                speedDict[SplitInfo.fan.x2] = b.splitState.fan.x2;
                speedDict[SplitInfo.fan.x3] = b.splitState.fan.x3;

                let fanText = "-";
                if (data["fan"] !== undefined) {
                    fanText = speedDict[data["fan"]];
                }

                let tempText = "-";
                if (data["set_point"] !== undefined) {
                    tempText = localization.localizeNumber(data["set_point"].toFixed(1));
                }

                text = stringFormat(b.splitStateF,
                    modeDict[data["mode"]],
                    tempText,
                    fanText,
                );
            } else {
                text = b.turnOff;
            }
        } else if (data.device_type === DeviceType.tvRemote) {
            if (Object.prototype.hasOwnProperty.call(data, "power")) {
                text = b.tvPowerToggle;
            } else if (Object.prototype.hasOwnProperty.call(data, "mute")) {
                text = b.tvMuteToggle;
            } else if (Object.prototype.hasOwnProperty.call(data, "channel")) {
                text = stringFormat(b.tvSetChannelF, localization.localizeNumber(data["channel"]));
            }
        } else if (data.device_type === DeviceType.sedna) {
            if (data["is_on"]) {
                const modeDict = {};
                modeDict[SednaInfo.mode.heating] = se.heating;
                modeDict[SednaInfo.mode.cooling] = se.cooling;
                const speedDict = {};
                speedDict[SednaInfo.motorSpeed.high] = se.fast;
                speedDict[SednaInfo.motorSpeed.medium] = se.medium;
                speedDict[SednaInfo.motorSpeed.low] = se.slow;
                speedDict[SednaInfo.motorSpeed.auto] = se.auto;
                const scenarioDict = {};
                scenarioDict[SednaInfo.scenario.turbo] = se.turbo;
                scenarioDict[SednaInfo.scenario.sleep] = se.sleep;
                scenarioDict[SednaInfo.scenario.away] = se.leave;
                scenarioDict[SednaInfo.scenario.manual] = se.manual;

                text = stringFormat(b.sednaStateF,
                    modeDict[data["mode"]],
                    localization.localizeNumber(data["set_point"].toFixed(1)),
                    speedDict[data["motor_speed"]],
                    scenarioDict[data["scenario"]],
                );
            } else {
                text = b.turnOff;
            }
        } else if (data.device_type === DeviceType.hinavaEcoThermostat) {
            if (data["is_on"]) {
                const modeDict = {};
                modeDict[HinavaEcoThermostatInfo.mode.heating] = se.heating;
                modeDict[HinavaEcoThermostatInfo.mode.cooling] = se.cooling;
                modeDict[HinavaEcoThermostatInfo.mode.fan] = se.fan;
                const speedDict = {};
                speedDict[HinavaEcoThermostatInfo.fanSetting.high] = se.fast;
                speedDict[HinavaEcoThermostatInfo.fanSetting.medium] = se.medium;
                speedDict[HinavaEcoThermostatInfo.fanSetting.low] = se.slow;
                speedDict[HinavaEcoThermostatInfo.fanSetting.auto] = se.auto;

                if (data["turbo_setting"] === true) {
                    text = stringFormat(b.hinavaEcoThermostatStateTurboF,
                        modeDict[data["mode_setting"]],
                        localization.localizeNumber(data["set_point"].toFixed(1)),
                    );
                } else {
                    text = stringFormat(b.hinavaEcoThermostatStateF,
                        modeDict[data["mode_setting"]],
                        localization.localizeNumber(data["set_point"].toFixed(1)),
                        speedDict[data["fan_setting"]],
                    );
                }
            } else {
                text = b.turnOff;
            }
        } else if (data.device_type === DeviceType.evaporativeCooler) {
            // if (data.hasOwnProperty("power")) {
            if (Object.prototype.hasOwnProperty.call(data, 'power')) {
                text = (data["power"] === true) ?
                    s.createScenarioProcess.powerOn : s.createScenarioProcess.powerOff;
            } else {
                const power = data["pump"] || data["slow_fan"] || data["fast_fan"];

                text = stringFormat(b.coolerStateF,
                    power ? b.coolerStates.on : b.coolerStates.off,
                    data["pump"] ? b.coolerStates.on : b.coolerStates.off,
                    data["slow_fan"] ? b.coolerStates.slow : (
                        data["fast_fan"] ? b.coolerStates.fast : b.coolerStates.off)
                );
            }
        }
    }

    return BindInfoObject(BindReprObject(
        icon,
        deviceName,
        text
    ), data);
}

export function createBindGenericConditionInfoObject(section, item, deviceName, deviceMac, deviceType) {
    let __infoDataObject = {
        condition_type: BindConditionType.device,
        device_type: deviceType,
        device_mac: deviceMac
    };
    __infoDataObject[item.key] = item.value;

    return BindInfoObject(BindReprObject(
        item.icon,
        deviceName,
        (section.itemsHaveIndependentName === true) ?
            (item.title) : (section.name + ": " + item.title)
    ), __infoDataObject);
}

export function createBindGenericActionInfoObject(section, item, deviceName, deviceMac, deviceType) {
    let __infoDataObject = {
        action_type: BindActionType.device,
        device_type: deviceType,
        device_mac: deviceMac
    };
    __infoDataObject[item.key] = item.value;
    return BindInfoObject(BindReprObject(
        item.icon,
        deviceName,
        (section.itemsHaveIndependentName === true) ?
            (item.title) : (section.name + ": " + item.title)
    ), __infoDataObject);
}

export function getBindInfo(bind, devices, scenarios, localization) {
    // like the function above.

    let conditionInfos = [];
    let actionInfos = [];

    for (let i = 0; i < bind.conditions.length; i++) {
        const condData = bind.conditions[i];
        if (condData.condition_type === BindConditionType.device) { // device
            const device = findByMacInDevices(devices, condData.device_mac);
            if (device === undefined) {
                continue
            }
            const condTemplate = getBindTemplate(true, device, localization);
            if (condTemplate.type === BindTemplateType.optionList) {
                for (let j = 0; j < condTemplate.sections.length; j++) {
                    const section = condTemplate.sections[j];
                    if (section.type === BindSectionType.oneOf) {
                        for (let k = 0; k < section.items.length; k++) {
                            const item = section.items[k];
                            if (item.key === undefined) {
                                console.log("ERROR: (item.key === undefined) in getBindIcons", item);
                                continue;
                            }
                            if (condData.device_events[item.key] === item.value) {
                                conditionInfos.push(createBindGenericConditionInfoObject(section, item, device.name, device.mac, device.type));
                            }
                        }
                    } else if (section.type === BindSectionType.comparisonWithSlider) {
                        if (condData.device_events[section.key] !== undefined) {
                            conditionInfos.push(createBindComparisonConditionInfoObject(section, condData.device_events[section.key], device.name, device.mac, device.type, localization));
                        }
                    }
                }
            } else if (condTemplate.type === BindTemplateType.special) {
                let _tempData = {
                    condition_type: BindConditionType.device,
                    device_mac: device.mac,
                    device_type: device.type,
                }
                for (const key in condData.device_events) {
                    if (Object.prototype.hasOwnProperty.call(condData.device_events, key)) {
                        _tempData[key] = condData.device_events[key];
                    }
                }
                conditionInfos.push(createBindDeviceSpecialInfoObject(true, condTemplate.icon, device.name, _tempData, localization));
            }
        } else if (condData.condition_type === BindConditionType.alarm) { // alarm
            conditionInfos.push(createBindAlarmInfoObject(condData.time, localization));
        }
    }

    for (let i = 0; i < bind.actions.length; i++) {
        const actData = bind.actions[i];
        if (actData.action_type === BindActionType.device) { // device
            const device = findByMacInDevices(devices, actData.device_mac);
            if (device === undefined) {
                continue
            }
            const actTemplate = getBindTemplate(false, device, localization);
            if (actTemplate.type === BindTemplateType.optionList) {
                for (let j = 0; j < actTemplate.sections.length; j++) {
                    const section = actTemplate.sections[j];
                    if (section.type === BindSectionType.oneOf) {
                        for (let k = 0; k < section.items.length; k++) {
                            const item = section.items[k];
                            if (item.key === undefined) {
                                console.log("ERROR: (item.key === undefined) in getBindIcons", item);
                                continue;
                            }
                            if (actData.device_state[item.key] === item.value) {
                                actionInfos.push(createBindGenericActionInfoObject(section, item, device.name, device.mac, device.type))
                            }
                        }
                    }
                }
            } else if (actTemplate.type === BindTemplateType.special) {
                let _tempData = {
                    action_type: BindActionType.device,
                    device_mac: device.mac,
                    device_type: device.type,
                }
                for (const key in actData.device_state) {
                    if (Object.prototype.hasOwnProperty.call(actData.device_state, key)) {
                        _tempData[key] = actData.device_state[key];
                    }
                }
                actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, _tempData, localization));
            }
        } else if (actData.action_type === BindActionType.scenario) { // scenario
            const scenario = findScenario(scenarios, actData.scenario_id);
            if (scenario === undefined) {
                continue
            }
            actionInfos.push(createBindScenarioInfoObject(localization, scenario.id, scenario.pic_id, scenario.name));
        } else if (actData.action_type === BindActionType.notiftcation) { // notif
            actionInfos.push(createBindNotifInfoObject(localization));
        } else if (actData.action_type === BindActionType.call) { // call
            actionInfos.push(createBindCallInfoObject(actData.phone_number, localization));
        } else if (actData.action_type === BindActionType.email) { // email
            actionInfos.push(createBindEmailInfoObject(actData.email, localization));
        } else if (actData.action_type === BindActionType.sms) { // sms
            actionInfos.push(createBindSMSInfoObject(actData.phone_number, localization));
        }
    }

    return [conditionInfos, actionInfos];
}

export function getRelatedBindsForADevice(binds, deviceMac) {
    const relatedBinds = [];
    for (let i = 0; i < binds.length; i++) {
        const bind = binds[i];
        let isThisBindRelated = false;
        for (let j = 0; j < bind.conditions.length; j++) {
            const condData = bind.conditions[j];
            if (condData.device_mac === deviceMac) {
                isThisBindRelated = true;
                break;
            }
        }
        if (!isThisBindRelated) {
            for (let j = 0; j < bind.actions.length; j++) {
                const actData = bind.actions[j];
                if (actData.device_mac === deviceMac) {
                    isThisBindRelated = true;
                    break;
                }
            }
        }
        if (isThisBindRelated) {
            relatedBinds.push(bind);
        }
    }
    return relatedBinds;
}

export function findByMacInDevices(devices, mac) {
    for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        if (device.mac === mac) {
            return device;
        } else if (device.sub_devices) {
            for (let j = 0; j < device.sub_devices.length; j++) {
                const subDevice = device.sub_devices[j];
                if (subDevice.mac === mac) {
                    return subDevice;
                }
            }
        }
    }
    return undefined;
}


function findScenario(scenarios, id) {
    for (let i = 0; i < scenarios.length; i++) {
        const scenario = scenarios[i];
        if (scenario.id === id) {
            return scenario;
        }
    }
    return undefined;
}

export function stringFormat(format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
    });
};
